import React from 'react';
import axios from "axios";
import WindowLocation from "../Services/WindowLocation";

export default class ListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            params: {},
            totalPages: 0,
            totalPosts: 0,
            loadMore: false,
            loaded: false,
            list: []
        };

        this.refAutoScroll = React.createRef();

        this.config = (this.props && this.props.config) ? this.props.config : null;
        this.perPage = (this.config && this.config.per_page) ? this.config.per_page : null;
        this.source = (this.config && this.config.source) ? this.config.source : null;
        this.isLoadMore = (this.config.loadMore === undefined || this.config.loadMore === 'loadMore');
        this.isPagination = (this.config.loadMore !== undefined && this.config.loadMore === 'pagination');

        this.page = 1;
        this.isChangeFilter = false;
        this.refList = [];

        this.objPublishEvents = null;

        this.windowLocationEventListener = this.windowLocationEventListener.bind(this);
        this.getList = this.getList.bind(this);
        this.setDefaultParams = this.setDefaultParams.bind(this);
        this.resetParams = this.resetParams.bind(this);
        this.updateParams = this.updateParams.bind(this);
        this.getResponseTotalPages = this.getResponseTotalPages.bind(this);
        this.getResponseTotalPosts = this.getResponseTotalPosts.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.loadPagination = this.loadPagination.bind(this);
        this.incrementPage = this.incrementPage.bind(this);
        this.changePage = this.changePage.bind(this);
        this.resetPage = this.resetPage.bind(this);
        this.requestList = this.requestList.bind(this);
        this.resetRefList = this.resetRefList.bind(this);
        this.publishEvents = this.publishEvents.bind(this);
        this.resetPublishEvents = this.resetPublishEvents.bind(this);
        this.scrollEvent = this.scrollEvent.bind(this);
    }

    componentDidMount() {
        if (!window.location.getHashObj) {
            WindowLocation.getWindowLocation();
        }

        window.addEventListener('changeWindowLocation', this.windowLocationEventListener);

        this.setDefaultParams().then(() => {
            if (window.location.hashObj && window.location.getHashObj('page') && window.location.getHashObj('page') > 1) {
                this.page = window.location.getHashObj('page');
            }

            let params = {
                page: this.page,
                forcePage: this.isPagination ? this.page : (this.page > 1),
                ...this.state.params,
                per_page: this.isPagination ? this.config.per_page : (this.config.per_page * this.page),
            };

            if (window.location.hashObj !== false) {
                this.scrollEvent();
            }

            if (this.source) {
                this.requestList(axios.get(this.source, {
                    params: params
                }));
            } else {
                this.getList();
            }

            this.addPublishEvents('componentDidMountIsLoaded');
        }).finally(() => {
            this.publishEvents();
        });
    }

    scrollEvent(element = this.refAutoScroll) {
        if (element && element.current) {

            let ref = element.current.refSectionList.current
            setTimeout(() => {

                //element.current.refSectionList.current.scrollIntoView({ top: 400, behavior: 'smooth', inline: 'nearest' });

                var evt = new CustomEvent('scrollToDOMElement', {
                    "detail": element.current.refSectionList.current
                });
                document.dispatchEvent(evt);

            }, 1);

        }
    }

    toggleElement(element = this.refAutoScroll) {
        if (element && element.current) {

            // let ref = element.current.refSectionList.current
            setTimeout(() => {

                //element.current.refSectionList.current.scrollIntoView({ top: 400, behavior: 'smooth', inline: 'nearest' });

                var evt = new CustomEvent('slideToggleDOMElement', {
                    "detail": element.current.refSectionList.current
                });
                document.dispatchEvent(evt);

            }, 1);

        }
    }

    windowLocationEventListener({windowGet: key, windowValue: value}) {
        if (key === undefined || value === undefined) {
            return false;
        }
        this.scrollEvent();

        this.resetParams(() => {
            const {state: {params}} = this;
            let sections = params[key] ?? null;

            if (!sections) {
                sections = [value];
            } else {
                let checked = sections.indexOf(value);

                if (checked > -1) {
                    sections = sections.filter((section, index) => index !== checked);
                } else {
                    if (typeof sections === "string") {
                        sections = [sections];
                    }

                    sections = [...sections, value];
                }
            }

            this.updateParams(key, sections);
            window.location.addHash(key, sections);
            WindowLocation.rewriteUrl();
        });
    }

    setDefaultParams() {
        return new Promise(resolve => {
            const {params} = this.config;

            if (params) {
                let setDefaultParams = {};

                for (let key in params) {
                    if (!params.hasOwnProperty(key)) {
                        continue;
                    }

                    const {key: name, default: defaultValue} = params[key];
                    setDefaultParams[name] = (window.location.hashObj && window.location.getHashObj(name)) ? window.location.getHashObj(name) : (defaultValue ? defaultValue : null);
                }

                if (window.location.hashObj && window.location.getHashObj('s')) {
                    setDefaultParams.s = window.location.getHashObj('s');
                }

                this.setState({
                    params: setDefaultParams
                }, resolve);
            } else {
                resolve();
            }

            return true;
        });
    }

    resetParams(callback = () => {
    }) {
        const {params} = this.config;
        const {state: {params: activeParams}} = this;
        let resetParams = {};

        for (let key in params) {
            if (!params.hasOwnProperty(key)) {
                continue;
            }

            if(!params[key].hasOwnProperty('lockParam') || false === params[key].lockParam) {
                resetParams[params[key].key] = params[key].default ? params[key].default : null;
                window.location.removeHash(params[key].key);
            }else{
                resetParams[params[key].key] = activeParams.hasOwnProperty(key) ? activeParams[key] : null;
            }
        }

        resetParams.s = null;
        window.location.removeHash('s');

        this.setState({
            params: resetParams
        }, callback);
    }

    updateParams(key, value, callback = this.getList) {
        this.resetPage();
        this.resetRefList();

        this.setState({
            params: {
                ...this.state.params,
                [key]: value
            }
        }, callback);
    }

    sleep = (miliseconde = 500) => {
        return new Promise(resolve => setTimeout(resolve, miliseconde));
    }

    getList() {
        this.setState({
            loaded: false
        }, async () => {
            await this.sleep(350);

            let params = {
                page: this.page,
                ...this.state.params
            };

            if (this.perPage) {
                params.per_page = this.perPage;
            }

            this.requestList(axios.get(this.source, {
                params: params
            }));
        });
    }

    getResponseTotalPages(request) {
        if (request && request.getResponseHeader) {
            let pages = request.getResponseHeader('x-wp-totalpages');

            this.setState({
                totalPages: pages ? parseInt(pages) : 0
            })
        }
    }

    getResponseTotalPosts(request) {
        if (request && request.getResponseHeader) {
            let posts = request.getResponseHeader('x-wp-total');

            this.setState({
                totalPosts: posts ? parseInt(posts) : 0
            })
        }
    }

    loadMore(event) {
        if (event) {
            event.preventDefault();
        }

        this.setState({
            loadMore: true
        }, () => {
            this.incrementPage();
            this.getList();
        });
    }

    loadPagination(event) {
        if (event) {
            event.preventDefault();
        }

        if (event.page) {
            this.scrollEvent();
            this.changePage(event.page);
            this.getList();
        }
    }

    incrementPage(page = null) {
        if (page) {
            this.page = page;
            return;
        }

        this.page++;
        window.location.addHash('page', this.page);
        WindowLocation.rewriteUrl();
    }

    changePage(page = 1) {
        this.page = page;
        window.location.addHash('page', this.page);
        WindowLocation.rewriteUrl();
    }

    resetPage() {
        this.page = 1;
        window.location.removeHash('page');
    }

    requestList(request) {
        request.then(({data: articleList, request}) => {
            const {loadMore, loaded, list} = this.state;

            this.getResponseTotalPages(request);
            this.getResponseTotalPosts(request);

            let articles;

            if (list && list.length && loadMore) {
                articles = [...list];
            }

            if (articleList.length) {

                if (articles) {
                    articleList.map(article => {
                        let isArticleInList = articles.find(a => article.id === a.id);

                        if (!isArticleInList) {
                            articles.push(article);
                        }
                    });
                } else {
                    articles = [...articleList];
                }

            }

            this.setState({
                list: articles,
                loaded: true,
                loadMore: false
            }, () => {
                this.publishEvents();
            });
        }).catch((error) => {
            this.setState({
                loaded: true,
                loadMore: false
            });

            console.error(error);
        });
    }

    resetRefList() {
        this.refList = [];
    }

    addPublishEvents(event) {
        if (!event) {
            return false;
        }

        this.objPublishEvents = !this.objPublishEvents ? [] : this.objPublishEvents;

        this.objPublishEvents.push(event);
    }

    publishEvents() {
        let self = this;
        // setInterval(function () {
        if (self.objPublishEvents) {
            self.objPublishEvents.map(event => document.dispatchEvent(new Event(event)));

            self.resetPublishEvents();
        }
        // }, 100);
    }

    resetPublishEvents() {
        this.objPublishEvents = null;
    }
}